<template>
  <v-row>
    <v-col cols="12">
      <v-tabs v-model="stepsTab">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          active-class="slider-tab-text"
          disabled
          v-for="item in stepsList"
          :key="item.value"
          link
          :to="item.to"
        >
          <h4>{{ $t(item.activeText) }}</h4>
        </v-tab>
      </v-tabs>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ElMandateStep',
  props: {
    step: String,
  },
  data() {
    return {
      stepsTab: null,
    }
  },
  computed: {
    steps() {
      return [
        {
          value: 1,
          label: '1',
          text: 'Įgaliojimo duomenys',
        },
        {
          value: 2,
          label: '2',
          text: 'Įgaliojimo asmenys',
        },
        {
          value: 3,
          label: '3',
          text: 'Kontaktiniai duomenys',
        },
        {
          value: 4,
          label: '4',
          text: 'Peržiūra',
        },
        {
          value: 5,
          label: '5',
          text: 'Apmokėjimas',
        },
      ]
    },
    stepsList() {
      return this.steps.map((item) => {
        item.activeText = item.value == this.step ? item.text : item.label
        item.to = {
          name: 'mandateSteps',
          params: { step: item.value.toString() },
        }
        return item
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
